import { animated, useSpring } from 'react-spring';
import {
  getSiteViewportFullscreen,
  getSiteViewportSelectorVisible,
  getSiteViewportSize,
} from '../../../selectors';
import { AdminSiteViewportContainer } from './admin-site-viewport-container';
import { AdminSiteViewportEditButton } from './admin-site-viewport-edit-button';
import { AdminSiteViewportFullscreenButton } from './admin-site-viewport-fullscreen-button';
import { AdminSiteViewportIframe } from './admin-site-viewport-iframe';
import { AdminSiteViewportPositioner } from './admin-site-viewport-positioner';
import { AdminSiteViewportShifter } from './admin-site-viewport-shifter';
import React from 'react';
import { SiteViewportPresetSelector } from './site-viewport-preset-selector';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
`;

const AnimatedWrapper = animated(Wrapper);

export const AdminSiteViewport: React.FunctionComponent<
  React.HTMLAttributes<HTMLDivElement>
> = (props): React.ReactElement => {
  const { height, width } = useSelector(getSiteViewportSize);
  const isSelectorVisible = useSelector(getSiteViewportSelectorVisible);
  const isFullscreen = useSelector(getSiteViewportFullscreen);

  const { padding } = useSpring({
    to: {
      padding: isFullscreen ? '0' : '1rem',
    },
  }) as any;

  return (
    <AnimatedWrapper
      {...props}
      style={{
        ...props.style,
        paddingTop: padding.interpolate((v: string): string => v),
      }}
    >
      <SiteViewportPresetSelector style={{ zIndex: 2 }} />
      <AdminSiteViewportShifter
        shiftDown={isSelectorVisible}
        style={{ flex: 1, position: 'relative', zIndex: isFullscreen ? 3 : 1 }}
      >
        <AdminSiteViewportPositioner
          style={{
            ...props.style,
            paddingRight: padding.interpolate((v: string): string => v),
            paddingBottom: padding.interpolate((v: string): string => v),
          }}
        >
          <AdminSiteViewportContainer style={{ height, width }}>
            <AdminSiteViewportFullscreenButton />
            <AdminSiteViewportEditButton />
            <AdminSiteViewportIframe />
          </AdminSiteViewportContainer>
        </AdminSiteViewportPositioner>
      </AdminSiteViewportShifter>
    </AnimatedWrapper>
  );
};

AdminSiteViewport.displayName = 'AdminSiteViewport';
